import type {
  CoreBookingDocumentResponseSingle,
  CoreGenerateContractPayload,
  ParameterID,
} from '@flecto/types'

import { api } from '../../../services/api'

export async function generateContract(
  bookingId: ParameterID,
  contract: CoreGenerateContractPayload
): Promise<CoreBookingDocumentResponseSingle> {
  const response = await api.post(
    `/api/saas/me/bookings/${bookingId}/documents/contract/generate_pdf`,
    contract
  )

  return response?.data
}
